import { render, staticRenderFns } from "./QTokenText.vue?vue&type=template&id=df83fea8&scoped=true"
import script from "./QTokenText.vue?vue&type=script&lang=js"
export * from "./QTokenText.vue?vue&type=script&lang=js"
import style0 from "./QTokenText.vue?vue&type=style&index=0&id=df83fea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df83fea8",
  null
  
)

export default component.exports